import React, { useEffect, useState } from "react";
import database from "../service/FirebaseConfig";
import "../assets/Projects.css"; // Import the custom CSS for styling

const ProjectsCard = ({ Projects }) => {
  return (
    <div className="Projects-card">
      <h1
        style={{
          width: "300px",
          overflowWrap: "break-word",
          textAlign: "left",
        }}
      >
        {Projects.name}
      </h1>
      <div className="Projects-details">
        <p>{Projects.description}</p>
        <a href={Projects.link} target="_blank" rel="noopener noreferrer">
          View More
        </a>
      </div>
    </div>
  );
};

const Projects = () => {
  const [Projects, setProjects] = useState([]);

  useEffect(() => {
    const ProjectsRef = database.ref("Projects");
    ProjectsRef.once("value", (snapshot) => {
      const ProjectsData = snapshot.val();
      if (ProjectsData) {
        const ProjectsList = Object.keys(ProjectsData).map((key) => ({
          id: key,
          ...ProjectsData[key],
        }));
        setProjects(ProjectsList);
      }
    });
  }, []);

  return (
    <div className="Projects-container">
      <h1 className="heading">Projects And Work</h1>
      <div className="Projects-list">
        {Projects.map((Projects) => (
          <ProjectsCard key={Projects.id} Projects={Projects} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
